import type { BookingSuccessInfo } from '../analytics';
import { sendEvent } from './lib';
import {
  calculateBaggageCount,
  filterProductsByPrice,
  buildAdditionalProducts,
} from './utils';

/**
 * flights_additional_product_page_opened - Перешел на страницу "Услуги"
 */
export const additionalProductPageOpened = () => {
  sendEvent('flights_additional_product_page_opened');
};

/**
 * flights_booking_button_clicked - Клик "Забронировать"
 */
export const bookingButtonClicked = (info: BookingSuccessInfo) => {
  const baggageCount = calculateBaggageCount(info.baggage);
  const hasBaggage = info.baggage && baggageCount > 0;
  const filteredProducts = filterProductsByPrice(info.products);
  const additionalProducts = buildAdditionalProducts(
    info,
    hasBaggage,
    filteredProducts,
  );

  sendEvent('flights_booking_button_clicked', {
    order_id: info.orderId,
    ancillary_baggage_count: baggageCount,
    additional_products: additionalProducts,
  });
};
